import Grid from '@mui/material/Grid2';
import { LoginForm } from 'components/LoginForm/LoginForm';
import LoginBackground from 'assets/cobrand/wellframe/WellframeLoginBackground.svg';
import React from 'react';
import { styled } from '@mui/material';
import { DeveloperTools } from 'components/DeveloperTools/DeveloperTools';
import { useDeveloperToolsActivation } from 'hooks/useDeveloperToolsActivation';

const DesktopTabletStyledGrid = styled(Grid)(({ theme }) => ({
  height: '100vh',
  backgroundImage: `url(${LoginBackground})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  [theme.breakpoints.down('sm')]: {
    background: 'none',
    alignItems: 'flex-start',
  },
}));
const DesktopTabletStyledGridItem = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(7),
  maxWidth: '540px',
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[4],
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
    boxShadow: 'none',
  },
}));

export const Login = () => {
  const { isVisible, handleLogoClick } = useDeveloperToolsActivation();

  return (
    <>
      {isVisible && <DeveloperTools />}
      <DesktopTabletStyledGrid container justifyContent="center" alignItems="center">
        <DesktopTabletStyledGridItem>
          <LoginForm onLogoClick={handleLogoClick} />
        </DesktopTabletStyledGridItem>
      </DesktopTabletStyledGrid>
    </>
  );
};
